export enum WorkflowStepDisplayStatus {
  Finish = 'finish',
  Process = 'process',
  Wait = 'wait',
}

interface WorkflowStepperState {
  status: WorkflowStepDisplayStatus
  isActive: boolean
  disabled: boolean
}

export function getWorkflowStepperState({
  stepIndex,
  activeStepIndex,
  maxNavigableIndex,
  workflowComplete,
  inactive = false,
}: {
  stepIndex: number
  activeStepIndex: number
  maxNavigableIndex: number
  workflowComplete: boolean
  /** The step is routed past by the ticket's field values. */
  inactive?: boolean
}): WorkflowStepperState {
  if (inactive) {
    return {
      status: WorkflowStepDisplayStatus.Wait,
      isActive: stepIndex === activeStepIndex,
      disabled: true,
    }
  }

  return {
    status: workflowComplete
      ? WorkflowStepDisplayStatus.Finish
      : stepIndex < maxNavigableIndex
        ? WorkflowStepDisplayStatus.Finish
        : stepIndex === maxNavigableIndex
          ? WorkflowStepDisplayStatus.Process
          : WorkflowStepDisplayStatus.Wait,
    isActive: stepIndex === activeStepIndex,
    disabled: !workflowComplete && stepIndex > maxNavigableIndex,
  }
}
